import { render, staticRenderFns } from "./formProperties.vue?vue&type=template&id=42ed0f5e"
import script from "./formProperties.vue?vue&type=script&lang=js"
export * from "./formProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports